export default __webpack_public_path__ + "static/media/tickets_QR_Validated.bb1adc79.svg";